import { z } from "zod";
import { zBillingPeriod, zCreditState } from "@/types/company/company.common";
import { zCorpCompanyStatus } from "@/types/corp/corpSession.common";
import { zCorpBannerKind } from "./corpCompany.common";
/** Сводка активной компании кабинета (UC1130) — `creditState` (BR-SET-08) и `banners` (BR-2) считает клиент. */
export const zCorpCompanySummaryDom = z.object({
    companyId: z.string(),
    name: z.string(),
    legalName: z.string().nullable(),
    inn: z.string().nullable(),
    status: zCorpCompanyStatus,
    creditLimit: z.number(),
    balance: z.number(),
    availableCredit: z.number(),
    overdueAmount: z.number(),
    overdueInvoicesCount: z.number(),
    openOrdersCount: z.number(),
    openOrdersExposure: z.number(),
    billingPeriod: zBillingPeriod,
    invoiceIssueDay: z.number(),
    paymentTermDays: z.number(),
    creditState: zCreditState,
    banners: z.array(zCorpBannerKind),
});
export const zCorpTariffSummaryDom = z.object({
    companyId: z.string(),
    idAdvance: z.string(),
    name: z.string(),
    advancePricePerKwh: z.number(),
    advanceOneTimeFee: z.number(),
    latePricePerKwh: z.number(),
    lateOneTimeFee: z.number(),
    cutoffHourMsk: z.number(),
    cutoffOffsetDays: z.number(),
});
